import { render } from "./ListComputers.vue?vue&type=template&id=8c749dae&ts=true"
import script from "./ListComputers.vue?vue&type=script&lang=ts"
export * from "./ListComputers.vue?vue&type=script&lang=ts"

import "./Computers.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__